import groupBy from 'lodash/groupBy'
import * as runbookModules from 'src/store/modules/runbooks'
import difference from 'lodash/difference'
import range from 'lodash/range'
import intersection from 'lodash/intersection'
import uniq from 'lodash/uniq'

export const getResolverGroupIds = function (device) {
    const { keys } = this.cmdbData
    let groups = groupBy(device.child_devices, (d) => keys[d].resolver_group_id)
    let nonNullGroups = Object.keys(groups).filter((g) => g !== 'null')
    return nonNullGroups
}

export const getResolverGroups = function (device) {
    const { keys } = this.cmdbData
    let groups = groupBy(device.child_devices, (d) => keys[d].resolver_group)
    let nonNullGroups = Object.keys(groups).filter((g) => g !== 'null')
    return nonNullGroups
}

export const parseDevice = function (device, fromAction, parent) {
    const { mode, parameters, environments } = this.runbook
    const { keys, virps } = this.cmdbData
    const avZones = {}
    let newAction
    if (this.isVirpPg(device)) {
        let [virpCi, pg] = device.name.split('-')
        newAction = this.addNewAction({
            data: {
                ...this.mapDeviceToAction(keys[virpCi]),
                name: this.formatVirpName(virpCi, pg),
            },
            options: {
                fromAction,
                parent,
            },
            device: keys[virpCi],
        })
    } else {
        newAction = this.addNewAction({
            data: this.mapDeviceToAction(device),
            options: {
                fromAction,
                parent,
            },
            device,
        })
    }

    device.child_devices = device.children.filter((d) => !keys[d].solution)
    device.child_solutions = device.children.filter((d) => keys[d].solution)
    if (device.parents.length === 0) {
        let before = newAction.uid
        device.child_solutions.forEach((ci) => {
            before = this.parseDevice(keys[ci], before, false)
        })
    } else if (device.parents.length > 0 && device.child_solutions.length) {
        const hasVirps =
            device.child_solutions.filter((d) => this.isVirpPg(keys[d]))
                .length === device.child_solutions.length
        let before = newAction.uid
        if (hasVirps) {
            let avZones = {}
            device.child_solutions.forEach((d) => {
                const [virp, pg] = keys[d].name.split('-')
                if (!keys[virp] || !virps[virp]) return
                if (!virps[virp][pg]) return
                const ci = {
                    ...keys[virp],
                    children: virps[virp][pg].filter((c) => keys[c]),
                }
                const extractedAvZones = this.extractAvZones(
                    ci,
                    { keys, virps },
                    this.runbook
                )
                for (let avZ in extractedAvZones) {
                    if (avZones[avZ]) {
                        avZones[avZ].push(d)
                    } else {
                        avZones[avZ] = [d]
                    }
                }
            })
            Object.entries(avZones).forEach(([avZ, cis]) => {
                let avAction = this.addNewAction({
                    data: {
                        name: avZ,
                        customerId: device.customer_id,
                        customer: device.organization,
                        isAvZone: true,
                        // ownerTeam: newAction.ownerTeam,
                        // ownerTeamId: newAction.ownerTeamId,
                    },
                    options: {
                        fromAction: newAction.uid,
                        parent: true,
                    },
                })
                cis.forEach((ci) => {
                    this.parseDevice(keys[ci], avAction.uid, true)
                })
            })
        } else {
            device.child_solutions.forEach((ci, i) => {
                before = this.parseDevice(keys[ci], before, i === 0)
            })
        }
    } else if (device.child_devices.length) {
        let groups = this.getResolverGroups(device)
        if (groups.length === 1) {
            let groupId = parseInt(this.getResolverGroupIds(device)[0], 10)
            newAction.ownerTeam = groups[0]
            newAction.cmdbOwnerTeam = groups[0]
            newAction.cmdbOwnerTeamId = groupId
            newAction.ownerTeamId = groupId
        }

        // Filter child devices based on runbook params
        if (mode === runbookModules.DR_SOLUTIONS_FAILOVER) {
            // DC is always 1 value, that's why we can take parameters[0] here
            device.child_devices = device.child_devices.filter(
                (d) =>
                    (keys[d].main_availability_zones.includes(parameters[0]) ||
                        keys[d].main_availability_zones.includes(
                            parameters[1]
                        ) ||
                        keys[d].main_availability_zones.some(
                            (avz) => !avz.startsWith('DC-')
                        )) &&
                    environments.includes(keys[d].cgk_environment)
            )
        } else if (mode === runbookModules.DR_SOLUTIONS_RESTART) {
            device.child_devices = device.child_devices.filter(
                (d) =>
                    keys[d].availability_zones.filter((value) =>
                        parameters.includes(value)
                    ).length && environments.includes(keys[d].cgk_environment)
            )
        }
        device.child_devices.forEach((d) => {
            keys[d].availability_zones.forEach((avZ) => {
                if (
                    mode === runbookModules.DR_SOLUTIONS_RESTART &&
                    !parameters.includes(avZ)
                )
                    return
                if (avZones[avZ]) {
                    avZones[avZ].push(d)
                } else {
                    avZones[avZ] = [d]
                }
            })
        })
        Object.entries(avZones).forEach(([avZ, devices]) => {
            let avAction = this.addNewAction({
                data: {
                    name: avZ,
                    customerId: device.customer_id,
                    customer: device.organization,
                    ownerTeam: newAction.ownerTeam,
                    ownerTeamId: newAction.ownerTeamId,
                    isAvZone: true,
                },
                options: {
                    fromAction: newAction.uid,
                    parent: true,
                },
            })
            devices.forEach((ci) => {
                this.parseDevice(keys[ci], avAction.uid, true)
            })
        })
    } else if (virps && this.isVirpPg(device)) {
        let [virpCi, pg] = device.name.split('-')
        if (virps[virpCi][pg]) {
            virps[virpCi][pg].forEach((vm) => {
                this.parseDevice(keys[vm], newAction.uid, true)
            })
        }
    }

    return newAction.uid
}

export const extractDevices = function (children, onlySolutions = false) {
    return children.filter(
        (c) => this.cmdbData.keys[c].solution === onlySolutions
    )
}

export const extractCiToUid = function (actionsList, onlySolutions) {
    // converts a list of actions into a dict
    // with hi to id references and an ordered list
    const result = { ordered: [], mapping: {} }
    actionsList.forEach((uid) => {
        const action = this.actionsMap[uid]
        if (action) {
            if (
                (onlySolutions && this.isSolution(action)) ||
                (!onlySolutions && action.device)
            ) {
                if (this.isVirp(action)) {
                    const pg = this.extractVirpPg(action)
                    const name = `${action.device}-${pg}`
                    result.ordered.push(name)
                    result.mapping[name] = uid
                } else {
                    result.ordered.push(action.device)
                    result.mapping[action.device] = uid
                }
            }
        }
    })
    return result
}

export const extractCurrentAvZones = function (uid) {
    const action = this.actionsMap[uid]
    if (action) {
        return action.children
            .filter((a) => {
                const childAction = this.actionsMap[a]
                return childAction && childAction.isAvZone
            })
            .reduce((agg, avZUid) => {
                const azAction = this.actionsMap[avZUid]
                if (azAction) {
                    agg[azAction.name] = {
                        uid: avZUid,
                        children: [...azAction.children],
                    }
                }
                return agg
            }, {})
    }
    return {}
}

export const diffActionsWithDevices = function (ciToUid, devices) {
    const { ordered, mapping } = ciToUid
    difference(ordered, devices).forEach((ci) => {
        this.markActionForDeletion(mapping[ci])
    })
    const intersection = ordered.filter((ci) => devices.includes(ci))
    intersection.forEach((ci) => {
        this.refreshActionFromCmdb(mapping[ci])
    })
    return difference(devices, ordered)
}

export const mergeDevices = function (uid, newDevices) {
    const { keys } = this.cmdbData
    for (let i = 0; i < newDevices.length; i++) {
        const [ci, pg] = newDevices[i].split('-')
        const data = this.mapDeviceToAction(keys[ci])
        let newAction = this.addNewAction({
            data: {
                ...data,
                name: pg ? this.formatVirpName(ci, pg) : data.name,
            },
            options: {
                fromAction: uid,
                parent: true,
            },
            device: keys[ci],
        })
        if (pg) {
            this.refreshVirpSolution(newAction)
        } else {
            this.refreshCache[newAction.uid] = true
        }
    }
}

export const mergeNewSolutions = function (
    parent,
    newSolutions,
    ciToUid,
    trigger = false
) {
    // Get the solutions of the customer from the cmdbData
    const { keys } = this.cmdbData

    const [lastCi] = ciToUid.ordered.slice(-1)
    let lastUid = ciToUid.mapping[lastCi]
    for (let i = 0; i < newSolutions.length; i++) {
        let device = keys[newSolutions[i]]
        let topOrTriggerSolution = false
        const parentAction = this.actionsMap[parent]
        if (parentAction) {
            if (
                this.getActionType(parentAction) === 'trigger' ||
                this.getActionType(parentAction) === 'topsolution'
            ) {
                topOrTriggerSolution = true
            }
        }
        let newAction = this.addNewAction({
            data: this.mapDeviceToAction(device),
            options: {
                fromAction: topOrTriggerSolution
                    ? parent
                    : lastUid
                    ? lastUid
                    : parent,
                parent: topOrTriggerSolution
                    ? true
                    : trigger
                    ? false
                    : !lastUid,
            },
            device,
        })
        if (newAction && newAction.uid) {
            this.refreshActionFromCmdb(newAction.uid)
            lastUid = newAction.uid
        }
    }
}

/**
 * Refreshes a trigger solution type action accordingly to the cmdb data.
 */
export const refreshTriggerSolution = function (action) {
    const { keys } = this.cmdbData
    // search siblings for all DR Solutions down the same depth
    const descendants = []
    this.addActionToList(action.uid, descendants, false)
    const ciToUid = this.extractCiToUid(action.treeChildren, true)
    const solutions = this.extractDevices(keys[action.device].children, true)
    // if any solutions are not found in this one's children, mark them for deletion
    const newSolutions = this.diffActionsWithDevices(ciToUid, solutions)
    // if solutions are missing, add them after the one they should be based on the order
    // refresh all solutions that are added
    this.mergeNewSolutions(action.uid, newSolutions, ciToUid, true)
    // const newDescendants = []
    // this.addActionToList(action.uid, newDescendants, false)

    // disable sorting during refresh TODO delete if business approves
    // if (action.nextSibling) {
    //     this.sortChildActions(action.uid, [action.nextSibling], false)
    // }

    this.refreshCache[action.uid] = true
}

/**
 * Refreshes a top solution type action accordingly to the cmdb data.
 */
export const refreshTopSolution = function (action) {
    const { keys } = this.cmdbData
    const { uid } = action
    const ciToUid = this.extractCiToUid(action.treeChildren, true)
    const solutions = this.extractDevices(keys[action.device].children, true)
    const newSolutions = this.diffActionsWithDevices(ciToUid, solutions)
    // new solutions can be regular ones or VIRPpgs
    this.mergeNewSolutions(uid, newSolutions, ciToUid)

    // disable sorting during refresh TODO delete if business approves
    // this.sortChildActions(uid, action.children)

    this.refreshCache[uid] = true
}

/**
 * Refreshes a solution type action accordingly to the cmdb data.
 */
export const refreshRegularSolution = function (action, selectedAvZones) {
    const { keys, virps } = this.cmdbData
    const { uid } = action
    const currentAction = this.actionsMap[uid]
    let avZones = {}
    if (currentAction && keys[currentAction.device]) {
        avZones = this.newExtractAvZones(
            keys[currentAction.device].children,
            keys,
            virps
        )
    }

    if (selectedAvZones) {
        for (let aZ in avZones) {
            if (!selectedAvZones.includes(aZ)) {
                delete avZones[aZ]
            }
        }
    }
    if (this.avZonesFilter.length) {
        for (let aZ in avZones) {
            if (!this.avZonesFilter.includes(aZ)) {
                delete avZones[aZ]
            }
        }
    }
    const oldAvZones = this.extractCurrentAvZones(uid)
    for (let aZ in avZones) {
        const devices = avZones[aZ]
        if (aZ in oldAvZones) {
            const ciToUid = this.extractCiToUid(oldAvZones[aZ].children)
            const newDevices = this.diffActionsWithDevices(ciToUid, devices)
            this.mergeDevices(oldAvZones[aZ].uid, newDevices)
            this.refreshCache[oldAvZones[aZ].uid] = true
        } else {
            let avAction = this.addAvAction(aZ, action)
            this.mergeDevices(avAction.uid, devices)
            this.refreshCache[avAction.uid] = true
        }
    }
    if (!selectedAvZones) {
        for (let aZ in oldAvZones) {
            if (!(aZ in avZones)) {
                this.markActionForDeletion(oldAvZones[aZ].uid)
            }
        }
        this.refreshCache[action.uid] = true
    }
}

/**
 * Refreshes a virp solution type action accordingly to the cmdb data.
 */
export const refreshVirpSolution = function (action) {
    const { keys, virps } = this.cmdbData
    const pg = this.extractVirpPg(action)
    let devices = virps[action.device][pg]
    if (this.avZonesFilter.length) {
        devices = devices.filter((ci) =>
            keys[ci].availability_zones.some((az) =>
                this.avZonesFilter.includes(az)
            )
        )
    } else if (action.treeParent) {
        const parent = this.actionsMap[action.treeParent]
        if (parent && parent.isAvZone) {
            devices = devices.filter((ci) =>
                keys[ci].availability_zones.includes(parent.name)
            )
        }
    }

    const ciToUid = this.extractCiToUid(action.children)
    const newDevices = this.diffActionsWithDevices(ciToUid, devices)
    this.mergeDevices(action.uid, newDevices)
    this.refreshCache[action.uid] = true
}

export const getActionType = function (action) {
    const { keys, top } = this.cmdbData
    // avzone refreshes it's devices
    if (action.isAvZone) return this.actionTypes.avzone
    if (this.isSolution(action)) {
        if (top.includes(action.device)) {
            return this.actionTypes.trigger
        }
        const hasChildSolutions =
            action.treeChildren.some((c) => {
                const childAction = this.actionsMap[c]
                return childAction && this.isSolution(childAction)
            }) ||
            (keys[action.device] &&
                keys[action.device].children.some(
                    (c) =>
                        keys[c] && keys[c].solution && !this.isVirpPg(keys[c])
                ))
        // top solutions order their child solutions sequentially
        if (hasChildSolutions) {
            return this.actionTypes.topsolution
        }
        // solutions refresh their devices but grouped by av zone
        return this.actionTypes.solution
    }
    // virp refreshes it's devices (vms)
    if (this.isVirp(action)) return this.actionTypes.virp
    // device only refreshes it's props
    if (action.device) return this.actionTypes.device
    // default actions are ignored
    return this.actionTypes.def
}

/**
 * Refreshes an action accordingly to the cmdb data.
 */
export const refreshActionFromCmdb = function (uid) {
    // TODO: Incorporate multiple customer CMDB maps
    // TODO: Incorporate sorting order
    const { keys } = this.cmdbData
    const action = this.actionsMap[uid]

    if (!action) {
        return true
    }

    // If the device is not an AV zone and does not figure in the "keys" of the cmdbData
    // that has been retrieved from the backend that means that the device that stood behind
    // this action was deleted, therefore the action is being deleted as well.
    if (!keys[action.device] && !action.isAvZone) {
        this.markActionForDeletion(uid)
        return true
    }

    const actionType = this.getActionType(action)
    switch (actionType) {
        case this.actionTypes.device:
            if (keys[action.device]) {
                this.refreshActionFromDevice(uid, keys[action.device])
            }
            break
        case this.actionTypes.avzone:
            const parentAction = this.actionsMap[action.treeParent]
            if (parentAction) {
                this.refreshRegularSolution(parentAction, [action.name])
            }
            break
        case this.actionTypes.trigger:
            // this one needs to do something similar to topsolution
            // but its cmdb children need to become sequential siblings
            this.refreshTriggerSolution(action)
            break
        case this.actionTypes.topsolution:
            this.refreshTopSolution(action)
            break
        case this.actionTypes.solution:
            this.refreshRegularSolution(action)
            break
        case this.actionTypes.virp:
            this.refreshVirpSolution(action)
            break
        default:
            break
    }
}

/**
 * Recursively calculates the topmost action in a runbook starting from any action.
 */
export const getTopmostCmdbAction = function (action) {
    switch (this.getActionType(action)) {
        case this.actionTypes.device:
            if (action.treeParent) {
                const parentAction = this.actionsMap[action.treeParent]
                if (parentAction && parentAction.isAvZone) {
                    return this.getTopmostCmdbAction(parentAction)
                }
            }
            return action
        case this.actionTypes.virp:
            if (action.treeParent) {
                const parentAction = this.actionsMap[action.treeParent]
                if (parentAction && parentAction.isAvZone) {
                    return this.getTopmostCmdbAction(parentAction)
                }
            }
            return action
        case this.actionTypes.avzone:
            if (action.treeParent) {
                const parentAction = this.actionsMap[action.treeParent]
                if (parentAction && this.isSolution(parentAction)) {
                    return this.getTopmostCmdbAction(parentAction)
                }
            }
            return action
        case this.actionTypes.solution:
            if (action.treeParent) {
                const parentAction = this.actionsMap[action.treeParent]
                if (parentAction && this.isSolution(parentAction)) {
                    return this.getTopmostCmdbAction(parentAction)
                }
            }
            return action
        case this.actionTypes.topsolution:
            return action
        default:
            return null
    }
}

export const refreshSolutionsFromCmdb = function (uid, cmdbData, params) {
    if (!Object.keys(cmdbData?.keys ?? {}).length) {
        console.error('CMDB data is missing or invalid.', { cmdbData, params });
        return;
    }
    this.cmdbData = cmdbData
    this.avZonesFilter = params.avZones
    this.refreshCache = {}

    // If an action is specified, refresh only that action.
    // If no action is specified, refresh all the actions of the runbook.
    if (uid) {
        this.refreshActionFromCmdb(uid)
    } else {
        // TODO: Still need to handle list of top solutions

        // An action can be refreshed only if it has device or is an AV zone
        const refreshableActions = Object.keys(this.actionsMap).filter((a) => {
            const currentAction = this.actionsMap[a]
            return (
                currentAction &&
                (currentAction.device || currentAction.isAvZone)
            )
        })

        refreshableActions.forEach((uid) => {
            const action = this.actionsMap[uid]
            if (action) {
                let refreshableActionId = action.uid
                const actionType = this.getActionType(action)
                if (actionType !== this.actionTypes.trigger) {
                    const topmostAction = this.getTopmostCmdbAction(action)
                    if (topmostAction) {
                        refreshableActionId = topmostAction.uid
                    }
                }
                if (!this.refreshCache[uid]) {
                    this.refreshActionFromCmdb(refreshableActionId)
                }
            }
        })
    }
}

export const parseTopSolution = function (ci) {
    // get scenario from runbook and process top/keys from cmdbData
    const { keys } = this.cmdbData
    // first level turns children into a list of sequential actions
    // second level turns children into a child with a list of seq actions
    // third level, child devices
    this.topAction = this.parseDevice(keys[ci])
}

export const postProcessCiLinks = function () {
    const {
        ciToUid,
        actionsMap,
        cmdbData: { keys },
    } = this
    Object.keys(ciToUid)
        .filter((ci) => keys[ci].cmdb_class === 'Database')
        .forEach((db) => {
            const dbUids = Object.keys(ciToUid[db].uids)
            const parentCi = keys[db].attached_to
            if (parentCi && ciToUid[parentCi]) {
                let parentUids = Object.keys(ciToUid[parentCi].uids)
                if (parentUids.length === 1) {
                    dbUids.forEach((dUid) => {
                        const dbAction = actionsMap[dUid]
                        if (dbAction) {
                            dbAction.parents.push(parentUids[0])
                        }
                    })
                }
            } else {
            }
        })
}

export const processDrSolutions = function () {
    const { keys, top } = this.cmdbData
    if (!top?.length) {
        return
    }
    const topDrSolutions = top.filter(
        (ci) => keys[ci].cmdb_class === 'DR Solution'
    )
    if (topDrSolutions.length) {
        topDrSolutions.forEach((drSolution) => {
            let device = keys[drSolution]
            let newAction = this.addNewAction({
                data: this.mapDeviceToAction(device),
                device,
            })
            if (!this.topAction) this.topAction = newAction.uid
            this.refreshTriggerSolution(newAction)
        })
    }
    // else {
    // add subsequent dr solutions like we do with
    // the first one but sibling of the last 0 depth level uid
    // }
    this.markEmptySolutionsAsInfoOnly()
    this.postProcessCiLinks()
}

export const processCmdbData = function (cmdbData) {
    this.cmdbData = cmdbData
    this.ciToUid = {}
    this.avZonesFilter = []
    this.refreshCache = {}
    switch (this.runbook.mode) {
        case runbookModules.DR_SOLUTIONS_GENERIC:
        case runbookModules.DR_SOLUTIONS_RESTART:
        case runbookModules.DR_SOLUTIONS_FAILOVER:
            this.processDrSolutions()
            break
        case runbookModules.BUSINESS_SOLUTIONS:
            this.processBusinessSolutions()
            break
        default:
            break
    }
    return {
        byId: this.actionsMap,
        uids: range(1, this.lastUid),
        ciToUid: this.ciToUid,
        lastUid: this.lastUid,
        topAction: this.topAction,
    }
}

/**
 * Takes a list of visible actions (usually returned by `createActionsList`)
 * and returns actions that are not on the render path
 * @param uids
 * @returns {[]}
 */
export const getOrphanedUids = function (uids) {
    const { maxDepth } = this.runbook
    let depthGroups = groupBy(this.actionsMap, (a) => a.depth)
    const ids = []
    for (let i = 0; i <= maxDepth; i++) {
        let group = depthGroups[i] || []
        group.forEach((action) => {
            const { uid } = action
            if (!uids.includes(uid) && !ids.includes(uid)) {
                this.addActionToList(uid, ids)
            }
        })
    }
    ids.forEach((uid) => {
        const action = this.actionsMap[uid]
        if (action && action.depth === 0) {
            action.visible = true
        }
    })
    return ids
}

export const getState = function () {
    return {
        byId: this.actionsMap,
        // uids: range(1, this.lastUid),
        // ciToUid: this.ciToUid,
        lastUid: this.lastUid,
        topAction: this.topAction,
    }
}

export const isSolution = function (action) {
    return (
        action.deviceClass &&
        (action.deviceClass === 'DR Solution' ||
            action.deviceClass === 'Business Solution')
    )
}

export const isVirp = function (action) {
    return (
        action.deviceClass &&
        action.deviceClass === 'Virtual Infrastructure Recovery Plan'
    )
}

export const isVirpPg = function (device) {
    return device.cmdb_class === 'VIRP-PG'
}

export const formatVirpName = function (ci, pg) {
    return `VIRP ${ci}: PG ${pg}`
}
export const extractVirpPg = function (action) {
    return action.name.split(`VIRP ${action.device}: PG `)[1]
}

export const extractAvZones = function (device, { keys, virps }, runbook) {
    const avZones = {}
    if (device.children.filter((c) => keys[c].solution).length) {
        device.children
            .map((pg) => keys[pg])
            .forEach((virpCi) => {
                if (this.isVirpPg(virpCi)) {
                    const [virp, pg] = virpCi.name.split('-')
                    if (!keys[virp] || !virps[virp]) return
                    if (!virps[virp][pg]) return
                    virps[virp][pg].forEach((vm) => {
                        if (keys[vm]) {
                            keys[vm].availability_zones.forEach((avZ) => {
                                if (avZones[avZ]) {
                                    avZones[avZ].push(virpCi)
                                } else {
                                    avZones[avZ] = [virpCi]
                                }
                            })
                        }
                    })
                }
            })
    } else {
        device.children
            .filter((c) => !keys[c].solution)
            .forEach((d) => {
                keys[d].availability_zones.forEach((avZ) => {
                    if (avZones[avZ]) {
                        avZones[avZ].push(d)
                    } else {
                        avZones[avZ] = [d]
                    }
                })
            })
    }

    if (runbook.mode === runbookModules.DR_SOLUTIONS_RESTART) {
        // exclude avzones that are not parameters
        let common = intersection(Object.keys(avZones), runbook.parameters)
        Object.keys(avZones).forEach((avZ) => {
            if (!common.includes(avZ)) {
                delete avZones[avZ]
            }
        })
    }
    return avZones
}

/*
 * Duplicated function for extracting AV zones that should be adapted to have the same capabilities
 * as the extractAvZones function in order to get rid of the extractAvZones function and only keep this one.
 */
export const newExtractAvZones = function (children, keys, virps) {
    // TODO: Adapt this function to have the same capabilities
    //  as the one above so we can get rid of it
    const avZones = {}
    children.forEach((c) => {
        const child = keys[c]
        if (isVirpPg(child)) {
            // loop vms of the virp pg and add the virp pg to each vm's av zone (only once)
            let [virp, pg] = child.name.split('-')
            if (
                !virp ||
                !pg ||
                !keys[virp] ||
                !virps[virp] ||
                !virps[virp][pg]
            ) {
                return
            }
            for (let pg in virps[virp]) {
                virps[virp][pg].forEach((vm) => {
                    if (keys[vm])
                        keys[vm].availability_zones.forEach((aZ) => {
                            if (avZones[aZ]) {
                                avZones[aZ] = uniq([...avZones[aZ], child.name])
                            } else {
                                avZones[aZ] = [child.name]
                            }
                        })
                })
            }
        } else {
            child.availability_zones.forEach((aZ) => {
                if (avZones[aZ]) {
                    avZones[aZ].push(c)
                } else {
                    avZones[aZ] = [c]
                }
            })
        }
    })
    return avZones
}
